import { render } from "./Repayment.vue?vue&type=template&id=cd0fd144"
import script from "./Repayment.vue?vue&type=script&lang=js"
export * from "./Repayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__